import { useQueryParams } from '../../../../../hooks/UseQueryParams';
import { useAuthOptions } from '../../../../../hooks/useAuthOptions';
import { AUTHENTICATION_STATUSES } from '../../types';

const MODAL_QUERY_KEY = 'modal';
const MODAL_QUERY_VALUE = 'free-history-check';

export type UseFreeHistoryCheckModal = {
  isOpen: boolean;
  open: () => void;
  close: () => void;
};

export const useFreeHistoryCheckModal = (): UseFreeHistoryCheckModal => {
  const { checkIfQueryIsPresent, removeQueries, addQueries } = useQueryParams();
  const { handleLogin, status } = useAuthOptions();

  const isOpen =
    checkIfQueryIsPresent(MODAL_QUERY_KEY, MODAL_QUERY_VALUE) &&
    status === AUTHENTICATION_STATUSES.AUTHENTICATED;

  const addModalQueryToUrl = () =>
    addQueries({ [MODAL_QUERY_KEY]: MODAL_QUERY_VALUE });

  const open = () => {
    if (
      status === AUTHENTICATION_STATUSES.AUTHENTICATED ||
      status === AUTHENTICATION_STATUSES.LOADING
    ) {
      addModalQueryToUrl();
    } else {
      const url = new URL(location.href);
      url.searchParams.set(MODAL_QUERY_KEY, MODAL_QUERY_VALUE);
      handleLogin(url.href);
    }
  };

  const close = () => {
    removeQueries([MODAL_QUERY_KEY]);
  };

  return {
    isOpen,
    open,
    close,
  };
};
